import { render, staticRenderFns } from "./RequirementRelationModal.vue?vue&type=template&id=0adf77c6&scoped=true"
import script from "./RequirementRelationModal.vue?vue&type=script&lang=js"
export * from "./RequirementRelationModal.vue?vue&type=script&lang=js"
import style0 from "./RequirementRelationModal.vue?vue&type=style&index=0&id=0adf77c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adf77c6",
  null
  
)

export default component.exports